import { AsyncPropSelector } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Button, ButtonGroup, Popover } from '@superops/ui-design-system';
import React, { useCallback, useState } from 'react';
import { SVGIcon } from '@superops/super-icons';

function TextCell(props) {
  const { cell, params, _ticket } = props;
  const allProps = params || cell.column;
  const { editable, field, actions, accessor, entity } = allProps;
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = (
    <Button
      plainSecondary
      icon={<SVGIcon name="Edit" />}
      onClick={() => togglePopoverActive()}
    />
  );

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        case 'sop':
          serialisedValue = { sopId: val.sopId, name: val.name };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? typeof fieldValue === 'object'
        ? {
            name: fieldValue.name,
            label: fieldValue.name,
            value: fieldValue.name
          }
        : { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <div className="p10 min-w230 grow-1 mw-300">
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
          entity={entity || 'Ticket'}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                actions.save &&
                  actions.save(updatedProperties, ticket, props.data);
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  };
  const getDisplayValue = useCallback((cell) => {
    let val = '';
    const suffix = cell.column.suffix;
    if (typeof cell.value === 'object' && cell.value?.name) {
      val = cell.value?.name;
    } else if (cell.value === 0) {
      //Handling this case to override falsy case as metric happens to be zero at times
      val = String(cell.value);
    } else if (cell.value || cell.name) {
      val = cell.value || cell.name;
    }
    let baseClass = 'ellipsis';
    if (val)
      return (
        <div
          className={cell?.column?.isBold ? `${baseClass} bold` : baseClass}
          title={suffix ? `${val} ${suffix}` : val}
        >
          {suffix ? `${val} ${suffix}` : val}
        </div>
      );
    else return <DisabledTag>NA</DisabledTag>;
  });

  return !popoverActive ? (
    <div
      className={`flex actr pr8 mw-100 ${editable ? 'editable-cell' : 'cell'}`}
    >
      {getDisplayValue(cell)}

      {editable && (
        <div className="edit-actions ptr visibilityActions">{activator}</div>
      )}
    </div>
  ) : (
    <div className="flex actr pr8 mw-100 editable-cell">
      {getDisplayValue(cell)}

      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        {getTag()}
      </Popover>
    </div>
  );
}

export default TextCell;
